<template>
    <div>
        <adopted class="mb-6"/>
        <waiting-adoption class="mt-6" ref="workersWaitingAdoption"/>
    </div>
</template>
<script>

    import WaitingAdoption from './WaitingAdoption'
    import Adopted from './Adopted'

    export default {
        components: {
            WaitingAdoption,
            Adopted
        },
        data() {
            return {

            }
        },
        beforeRouteLeave(to, from, next) {
            if (this.$refs.workersWaitingAdoption.adoptWorkerPrompt) {
                this.$refs.workersWaitingAdoption.adoptWorkerPrompt = false
                next(false)
            } else {
                next()
            }
        }

    }
</script>
